export default "__VITE_PUBLIC_ASSET__f0a355e0__"